module.exports = __webpack_public_path__ + "static/Clivetownshend-ef79a1ce9f2123497263348e65acefc4.jpg";